import React from 'react';

import Groups from './Groups/Groups';
import AllUsers from './AllUsers';
import { Box, Typography } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import ShowTabs from 'components/tabs/ShowTabs';
import TabElement from 'components/tabs/TabElement';

const AllUsersPage = () => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ p: isMobile ? 0.5 : 2 }}>
      <Typography variant="h5" component="h1" sx={{ mb: 0.5 }}>
        Users
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Manage LiveZone users, permissions and group membership
      </Typography>
      <ShowTabs value="0">
        <TabElement label="Users" value="0">
          <AllUsers />
        </TabElement>
        <TabElement label="Groups" value="1">
          <Groups />
        </TabElement>
      </ShowTabs>
    </Box>
  );
};

export default AllUsersPage;
